(function () {
  if (window.__vehicleFinderInit) return;
  window.__vehicleFinderInit = true;

  // Bump the suffix if the data shape ever changes, to invalidate old caches.
  var CACHE_KEY = 'dogboxVehicles_v3'; // bumped from _v2: cached lists were truncated at 250

  function reset(sel) {
    var placeholder = sel.options[0];
    while (sel.firstChild) { sel.removeChild(sel.firstChild); }
    sel.appendChild(placeholder);
    sel.value = '';
  }
  function fill(sel, items) {
    reset(sel);
    items.forEach(function (item) {
      var o = document.createElement('option');
      o.value = item;
      o.textContent = item;
      sel.appendChild(o);
    });
  }
  function uniqueSorted(arr) { return Array.from(new Set(arr)).sort(); }

  var LOADING_LABEL = 'Loading vehicles...';

  function eachMakeSelect(fn) {
    document.querySelectorAll('[data-vehicle-finder] [data-vf-make]').forEach(fn);
  }

  // Show a clear loading state on the Make dropdown while the list downloads, instead of a
  // dead, greyed control. The original placeholder text is stashed so it can be restored.
  function setMakeLoading() {
    eachMakeSelect(function (sel) {
      var ph = sel.options[0];
      if (!ph) return;
      if (!sel.dataset.vfPlaceholder) sel.dataset.vfPlaceholder = ph.textContent;
      ph.textContent = LOADING_LABEL;
      sel.disabled = true;
    });
  }

  function restoreMakePlaceholder(sel) {
    var ph = sel.options[0];
    if (ph && sel.dataset.vfPlaceholder) ph.textContent = sel.dataset.vfPlaceholder;
  }

  // Coerce raw entries (from the data page OR the static fallback) into a clean shape.
  function normalize(list) {
    return (list || []).map(function (v) {
      var to = (v.to === null || v.to === undefined || v.to === '') ? null : parseInt(v.to, 10);
      return {
        make: v.make,
        model: v.model,
        from: parseInt(v.from, 10),
        to: (to === null || isNaN(to)) ? null : to,
        url: v.url
      };
    }).filter(function (v) { return v.make && v.url && !isNaN(v.from); });
  }

  function wireForms(vehicles) {
    if (!vehicles || !vehicles.length) return;
    document.querySelectorAll('[data-vehicle-finder]').forEach(function (form) {
      if (form.__vfWired) return;
      var makeSel = form.querySelector('[data-vf-make]');
      var modelSel = form.querySelector('[data-vf-model]');
      var yearSel = form.querySelector('[data-vf-year]');
      var submit = form.querySelector('[data-vf-submit]');
      if (!makeSel || !modelSel || !yearSel || !submit) return;
      form.__vfWired = true;

      restoreMakePlaceholder(makeSel);
      fill(makeSel, uniqueSorted(vehicles.map(function (v) { return v.make; })));
      makeSel.disabled = false;

      makeSel.addEventListener('change', function () {
        reset(modelSel); reset(yearSel);
        modelSel.disabled = true; yearSel.disabled = true; submit.disabled = true;
        if (!makeSel.value) return;
        var models = uniqueSorted(vehicles
          .filter(function (v) { return v.make === makeSel.value; })
          .map(function (v) { return v.model; }));
        fill(modelSel, models);
        modelSel.disabled = false;
      });

      modelSel.addEventListener('change', function () {
        reset(yearSel); yearSel.disabled = true; submit.disabled = true;
        if (!modelSel.value) return;
        var gens = vehicles.filter(function (v) { return v.make === makeSel.value && v.model === modelSel.value; });
        var years = {};
        var currentYear = new Date().getFullYear();
        gens.forEach(function (v) {
          var to = v.to ? v.to : currentYear;
          for (var y = v.from; y <= to; y++) { years[y] = true; }
        });
        var list = Object.keys(years).map(Number).sort(function (a, b) { return b - a; });
        fill(yearSel, list);
        yearSel.disabled = false;
      });

      yearSel.addEventListener('change', function () { submit.disabled = !yearSel.value; });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var year = parseInt(yearSel.value, 10);
        var match = vehicles.find(function (v) {
          return v.make === makeSel.value && v.model === modelSel.value &&
            v.from <= year && (v.to ? v.to : 9999) >= year;
        });
        if (match && match.url) window.location.href = match.url;
      });
    });
  }

  // Shown when the vehicle list cannot be loaded at all (data page unpublished, renamed, or
  // a network failure). Replaces the finder with a link to the full vehicle index, so the
  // customer still has a route to their vehicle instead of a permanently empty dropdown.
  // This replaced a 31KB static copy of every vehicle that used to be inlined on every page:
  // it drifted out of date and started pointing at URLs that 404'd, and a wrong fallback is
  // worse than an honest one.
  function showUnavailable() {
    var cfg = window.__dogboxVF || {};
    var href = cfg.indexUrl || '/pages/browse-by-vehicle';
    document.querySelectorAll('[data-vehicle-finder]').forEach(function (form) {
      if (form.__vfFallback) return;
      form.__vfFallback = true;
      var note = document.createElement('p');
      note.className = 'vehicle-finder__fallback';
      note.setAttribute('role', 'status');
      var a = document.createElement('a');
      a.href = href;
      a.textContent = 'Browse all vehicles';
      note.appendChild(document.createTextNode('The vehicle finder is unavailable right now. '));
      note.appendChild(a);
      form.replaceChildren(note);
    });
  }

  // Live read from the data template (templates/page.vehicle-data.liquid), invoked via
  // the alternate-template parameter (?view=vehicle-data) on a normal published page.
  // Using ?view= means no theme template has to be assigned in admin (the admin template
  // picker only lists the live theme's templates), so this works while the theme is still
  // unpublished - same pattern the cage-finder uses. Paginates at 250/page.
  //
  // Pages are followed via the `next` URL the feed reports, NEVER by appending "&page=N".
  // Shopify namespaces the pagination parameter per paginated resource (`page_0b059106`
  // here, not `page`), so a hand-built "&page=2" is silently served page 1 - which used to
  // hand this finder the same 250 rows twice and hide every vehicle past the 250th.
  function fetchPage(url) {
    return fetch(url, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('bad status ' + r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t.trim()); });
  }

  function fetchData(url) {
    var vf = window.__dogboxVF || {};
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    var base = vf.base || (url + sep + 'view=vehicle-data');
    // Page 1 may already be in flight from the early prefetch in vehicle-finder-config.liquid;
    // reuse it (refetching if that prefetch failed and resolved null).
    var firstPage = vf.prefetch
      ? vf.prefetch.then(function (d) { return d || fetchPage(base); })
      : fetchPage(base);

    var all = [];
    var seen = {};
    // Dedupe by URL. Pages should never overlap, but a repeat used to pass silently and
    // cost 20 vehicles; collapsing duplicates makes that fail loudly in the count instead.
    function collect(d) {
      if (!d || !d.vehicles) return;
      d.vehicles.forEach(function (v) {
        if (v && v.url && !seen[v.url]) { seen[v.url] = true; all.push(v); }
      });
    }
    // Walk the `next` chain the feed reports. Capped so a malformed feed cannot loop.
    function follow(d, depth) {
      collect(d);
      if (!d || !d.next || depth >= 50) { return all; }
      return fetchPage(d.next).then(function (nd) { return follow(nd, depth + 1); });
    }
    return firstPage.then(function (first) { return follow(first, 1); });
  }

  function start() {
    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) { wireForms(normalize(JSON.parse(cached))); return; }
    } catch (e) {}

    setMakeLoading();

    var cfg = window.__dogboxVF || {};
    var url = cfg.dataUrl || '/pages/vehicle-data';

    fetchData(url).then(function (list) {
      if (list && list.length) {
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(list)); } catch (e) {}
        wireForms(normalize(list));
      } else {
        showUnavailable();
      }
    }).catch(function () {
      showUnavailable();
    });
  }

  start();
})();
